import * as React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import StringWidget, { stringTemplate } from 'components/StringWidget/StringWidget';
import { buildRenderData } from './buildRenderData';
import { get } from 'lodash';
import styles from './FooterLinks.css';
class FooterLinks extends React.PureComponent {
    render() {
        const { renderData } = this.props;
        if (renderData.length === 0) {
            return null;
        }
        // TODO: If there's a categoryUrl set, we should wrap the displayText
        // with a link.
        return (<div className="row">
				<div className={cx('col gu12', styles['links'])}>
					<div className={styles['heading']}>
						<StringWidget strKey="topStories"/>:
						<a className={styles['brand-title']} href="/brands">
							{stringTemplate('brandDirectory')}
						</a>
					</div>
					{renderData.map(linkGroup => {
            return (<div className={styles['link-group']} key={linkGroup.key}>
								<span className={styles['display-text']}>{linkGroup.displayText}:</span>
								{linkGroup.links.map(link => {
                return (<a className={styles['seolink']} key={link.brandName} href={link.brandUrl}>
											{link.brandName}
										</a>);
            })}
							</div>);
        })}
				</div>
			</div>);
    }
}
function mapStateToProps(state, ownProps) {
    const footerData = get(state, 'seoMeta.metadata.links.footer');
    return {
        renderData: buildRenderData(footerData, ownProps.otracker)
    };
}
// The last generic type argument, and the {} mapDispatchToProps argument are
// being used because for some reason the PureComponent usage is messing
// up the type checking, throwing an error of missing `dispatch` property.
// Ideally this shouldn't happen, and there are lots of such usages in the
// codebase that don't run into this problem. Using either stateless or stateful
// component constructor also suppresses this type error. Possibly a bug
// in the type definition.
export default connect(mapStateToProps, {})(FooterLinks);
